





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { cloneDeep, isEqual } from 'lodash'
import { TriggeredReferral } from '@/api/model/triggered-referral'

@Component
export default class CreateAutoLeadFormStep4 extends Vue {
    @Prop({ required: true }) readonly value!: TriggeredReferral
    editingValue: TriggeredReferral = null

    @Watch('value', {immediate: true})
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
    }

    @Watch('editingValue.referralComment')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    get triggerType(): string {
        if (this.value.triggerType === 'agendaTypes') {
            return 'afspraak'
        } else if (this.value.triggerType === 'taakTypes') {
            return 'taak'
        } else if (this.value.triggerType === 'relatieTypes') {
            return 'relatie'
        } else {
            return 'kenmerk'
        }
    }

    get avatarHeaderText() {
        return this.$t('virtualColleague.autoLead.avatarHeader.stepFour', {
            referralReferredByBranch: this.value.referralReferredByBranch.name,
            referralReferredBy: this.value.referralReferredBy.name,
            referralAssignedToBranch: this.value.referralAssignedToBranch.name,
            maxDaysForExistingReferrals: this.value.maxDaysForExistingReferrals,
        })
    }
}
